import styles from './RadioButton.module.scss';

type Props = {
  inputName: string;
  register?(fieldName: string, registerOptions?: { [key: string]: any }): any;
  registerOptions?: { [key: string]: any };
  value?: string;
  id?: string;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const RadioButton = ({ inputName, register, registerOptions, value, id, ...props }: Props) => {
  return (
    <input
      type="radio"
      value={value}
      id={id}
      {...(register && register(inputName, registerOptions))}
      style={styles}
      {...props}
    />
  );
};
